export default {
    shakePinganActivity:
        "/gateway/huilianOperation/hoPinganActivitycs/shakePinganActivity", // 摇一摇
    checkPinganActivityEnable:
        "/gateway/huilianOperation/hoPinganActivitycs/free/checkPinganActivityEnable", // 活动是否生效
    pinganActivityUserCash:
        "/gateway/huilianOperation/hoPinganActivitycs/pinganActivityUserCash", // 用户平安金余额
    getUserCanShakeNum:
        "/gateway/huilianOperation/hoPinganActivitycs/getUserCanShakeNum", // 用户剩余当日可摇次数
    queryCourseRankList:
        "/gateway/huilianOperation/learningResultcs/queryCourseRankList", // 学习记录排行榜
    selectHoActivityManagementSimpleDetail:
        "/gateway/huilianOperation/hoActivityManagementcs/selectHoActivityManagementSimpleDetail", // 活动简要查看
    finishShareTask:
        "/gateway/huilianOperation/hoPinganActivitycs/finishShareTask", // 完成分享任务
    createCourse: "/gateway/huilianOperation/coursecs/createCourse", // 获取学习课程

    selectEntryByCust: "/gateway/huilianOperation/hoEntrycs/selectEntryByCust", // 查询我的活动报名
    insertEntry: "/gateway/huilianOperation/hoEntrycs/insertEntry", // 活动报名
    selectAnnualSafeStatistics:
        "/gateway/huilianOperation/hoEntrycs/selectAnnualSafeStatistics", // 查询年度安全数据统计

    baiRiActivityEnable:
        "/gateway/huilianOperation/hoBaiRiActivitycs/free/baiRiActivityEnable", // 百日行动活动是否生效
};



// WEBPACK FOOTER //
// ./src/peaceSharkIndex/index/api.js